import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CPFMaskDirective } from './cpf-mask.directive';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ CPFMaskDirective ],
    exports: [ CPFMaskDirective ],
})
export class CpfMaskDirectiveModule {}
